var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { RowInset } from "./subcomponents";
import { FieldValue, RowItem } from "../subcomponents";
var CustomerName = function (_a) {
    var _b, _c;
    var data = _a.data;
    var firstName = (_b = data === null || data === void 0 ? void 0 : data.profile) === null || _b === void 0 ? void 0 : _b["cipher.firstName"];
    var lastName = (_c = data === null || data === void 0 ? void 0 : data.profile) === null || _c === void 0 ? void 0 : _c["cipher.lastName"];
    var fullName = [firstName, lastName].join(" ");
    return (_jsx(RowInset, __assign({ top: "medium", bottom: "medium" }, { children: _jsx(RowItem, { children: _jsx(FieldValue, { children: fullName }) }) })));
};
export default CustomerName;
